import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import moment from 'moment';

import {
	isEmpty,
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

import TextareaCounter from '@/components/textarea-counter/textarea-counter';

export default {
	name: 'student-eventual-medicine',
	components: {
		TextareaCounter
	},
	data: () => ({
		medicine: {
			reason: '',
			time: '',
			medicine: '',
			dosage: ''
		}
	}),
	computed: {
		...mapState({
			eventualMedicines: (state) => state.Agenda.agenda.eventualMedicines
		}),
		...mapGetters({
			date: 'getAgendaDate'
		})
	},
	methods: {
		...mapActions([
			'deleteEventualMedicineItem',
			'postAgendaEventualMedicineItem',
			'putAgendaEventualMedicineItem',
			'putCompletionStatus'
		]),
		completionStatus(model) {

			let status = false;

			if (isEmpty(model.time) && isEmpty(model.medicine) && isEmpty(model.dosage) && isEmpty(model.reason)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'eventualMedicine',
				value: status
			});

		},
		addEventualMedicineItem() {

			this.$validator.validateAll().then((valid) => {

				if (valid && this.getTimeDiff(this.medicine.time) > 0 && this.getTimeDiff(this.medicine.time) > 0) {

					this.medicine.time = this.medicine.time + ':00';

					if (this.medicine.index !== undefined && this.medicine.index >= 0) {
						this.putAgendaEventualMedicineItem(cloneDeep(this.medicine));
					} else {
						this.postAgendaEventualMedicineItem(cloneDeep(this.medicine));
					}

					this.medicine = {
						reason: '',
						time: '',
						medicine: '',
						dosage: ''
					};

					this.completionStatus(true);

				} else if (this.getTimeDiff(this.medicine.time) <= 0) {
					toastr.warning('O horário da medicação não pode ser uma data futura.');
				} else {
					toastr.warning('Por favor, informe todos os campos relacionados a soneca.');
				}

			});

		},
		editEventualMedicineItem(index) {

			this.medicine = cloneDeep(this.eventualMedicines[index]);
			this.medicine.index = index;

		},
		getTimeDiff(time) {

			if (time) {

				const [year, month, date] = this.date.split('-');
				const [hour, minute] = time.split(':');

				return moment().diff(
					moment().set({
						year,
						month: (month - 1),
						date,
						hour,
						minute,
						second: 0
					})
				);

			}

		}
	},
	mounted() {

		EventBus.$on('setStudent', () => {

			this.medicine = {
				reason: '',
				time: '',
				medicine: '',
				dosage: ''
			};

		});

	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/health/eventual-medicine/index.js